/**
 * React Query hooks for the System Map screen. The vault changes rarely
 * (it's re-vendored on demand), so a long staleTime is fine.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchBrainTree, fetchBrainPage, fetchBrainGraph } from '@/api/adminBrain';

export function useBrainTree() {
  return useQuery({
    queryKey: ['brainTree'],
    queryFn: fetchBrainTree,
    staleTime: 5 * 60_000
  });
}

export function useBrainPage(path: string | null) {
  return useQuery({
    queryKey: ['brainPage', path],
    queryFn: () => fetchBrainPage(path as string),
    enabled: !!path,
    staleTime: 5 * 60_000
  });
}

export function useBrainGraph() {
  return useQuery({
    queryKey: ['brainGraph'],
    queryFn: fetchBrainGraph,
    staleTime: 5 * 60_000
  });
}
